<template>
  <div>
    <v-data-table
      :headers="headers"
      :items="events"
      :items-per-page="15"
      dense
      item-key="id"
      elevation="0"
    >
      <template v-slot:top>
        <v-toolbar flat class="mb-5">
          <v-toolbar-title>Явки сотрудника {{ employee.fullname }}</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn
            color="orange darken-3"
            icon
            outlined
            small
            @click="$emit('close')"
            class="mr-5"
          >
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-toolbar>
      </template>
      <template v-slot:item.status="{ item }">
        <v-btn :class="getEventStatusFillings(item)['class']">
          {{ getEventStatusFillings(item)['label'] }}
        </v-btn>
      </template>
      <template v-slot:item.is_night_schedule="{ item }">
        <v-btn :class="item.is_night_schedule ? 'blue-grey darken-3 white--text' : 'yellow' ">
          {{ item.is_night_schedule ? 'Ночь' : 'День' }}
        </v-btn>
      </template>
      <template v-slot:item.actions="{ item }">
        <v-btn @click.stop="openDialog(item)">
          open
        </v-btn>
      </template>
    </v-data-table>
  </div>
</template>

<script>
export default {
  name: "EmployeesEventsTable",
  data: () => ({
     headers: [
      { text: "Дата", align: "center", value: "date" },
      { text: "Изменен", align: "center", value: "is_confirmed" },
      { text: "Статус ошибки", align: "center", value: "status" },
      { text: "Оклад", align: "center", value: "regular" },
      { text: "Бонус", align: "center", value: "bonus" },
      { text: "Ночь", align: "center", value: "is_night_schedule" },
      { text: "", align: "center", value: "actions" },
    ],
  })
}
</script>

<style scoped>

</style>